import React, { useMemo, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, Layout } from "@folio/stripes/components";
import { useQuery } from "react-query";
import { EnforcementTimeline } from "../enforcement/EnforcementTimeline";
import { fetchCheckTaskCommunications } from "../../api/periodicalCheckService";
var toTimelineEvent = function (communication) { return ({
    id: communication.id,
    date: communication.sentDate,
    eventType: "COMMUNICATION",
    label: communication.communicationType,
    userName: communication.userName,
    subject: communication.subject,
    notes: communication.notes,
    recipientAddress: communication.recipientAddress,
}); };
export var PeriodicalCheckHistory = function (_a) {
    var taskId = _a.taskId;
    var kyInstance = useOkapiKy();
    var _b = useState(false), historyOpen = _b[0], setHistoryOpen = _b[1];
    var _c = useQuery(["periodicalCheckCommunications", taskId], function () { return fetchCheckTaskCommunications(kyInstance, taskId); }, { cacheTime: 60000, enabled: historyOpen }).data, communications = _c === void 0 ? [] : _c;
    var events = useMemo(function () { return communications.map(toTimelineEvent); }, [communications]);
    return (React.createElement(Layout, { className: "padding-top-gutter" },
        React.createElement(Button, { onClick: function () { return setHistoryOpen(function (open) { return !open; }); }, marginBottom0: true },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.enforcement.action.history" })),
        historyOpen && (React.createElement(EnforcementTimeline, { events: events, titleMessageId: null, emptyMessageId: "ui-br-legaldeposits.periodicalCheck.history.empty" }))));
};
